import * as React from "react";
import {DashboardUser} from "../../../generated/protocol";

interface Props {
    user: DashboardUser;
}

export class DashboardUserProfile extends React.Component<Props, {}> {
    getAvatar() {
        var index = Math.abs(this.hashCode(this.props.user.username)) % 6;
        return contextPath + "/images/avatar-" + index + ".png";
    }

    hashCode(str: string) {
        var hash = 0;
        if (str.length == 0) return hash;
        for (var i = 0; i < str.length; i++) {
            var char = str.charCodeAt(i);
            hash = ((hash << 5) - hash) + char;
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
    }

    render() {
        if (this.props.user == null) {
            return <div/>;
        }
        return (
            <div className="dropdown profile-element">
                 <span>
                     <img alt="image" className="img-circle" src={this.getAvatar()} width="50px"/>
                 </span>
                <a data-toggle="dropdown" className="dropdown-toggle" href="#">
                 <span className="clear">
                     <span className="block m-t-xs">
                         <strong className="font-bold"> {this.props.user.username}</strong>
                     </span>
                     <span className="text-muted text-xs block">
                         <span>{this.props.user.role}</span>
                         <b className="caret"></b>
                     </span>
                 </span>
                </a>
                <ul className="dropdown-menu animated fadeInRight m-t-xs">
                    <li><a href="profile.html">Profile</a></li>
                    <li><a href="contacts.html">Contacts</a></li>
                    <li><a href="mailbox.html">Mailbox</a></li>
                    <li className="divider"></li>
                    <li><a href="login.html">Logout</a></li>
                </ul>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/app/ui/user/DashboardUserProfile.tsx